// Fax Application Navigation Items

export const FaxNav = [
  {
    icon: "pe-7s-paper-plane",
    label: "Send Fax",
    to: "/fax/send",
  },
  {
    icon: "pe-7s-mail-open-file",
    label: "Received Faxes",
    to: "/fax/received",
  },
  {
    icon: "pe-7s-mail",
    label: "Sent Faxes",
    to: "/fax/sent",
  },
];

export const AdminNav = [
  {
    icon: "pe-7s-users",
    label: "User Management",
    to: "/admin/users",
  },
];

export const MainNav = [
  {
    icon: "pe-7s-home",
    label: "Dashboard",
    to: "/fax/send",
  },
];

// Keep empty arrays for backward compatibility
export const ComponentsNav = [];
export const FormsNav = [];
export const WidgetsNav = [];
export const ChartsNav = [];
export const UpgradeNav = [];
